import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  patchRequest,
} from "../api/methodsCfg";

// Room API functions
export const getRoomsByRestaurant = async (restaurantId) => {
  const response = await getRequest(`/room/restaurant/${restaurantId}`);
  return response;
};

export const getRoomById = async (roomId) => {
  const response = await getRequest(`/room/${roomId}`);
  return response;
};

export const createRoom = async (restaurantId, data) => {
  const response = await postRequest(`/room/restaurant/${restaurantId}`, data);
  return response;
};

export const updateRoom = async (roomId, data) => {
  const response = await putRequest(`/room/${roomId}`, data);
  return response;
};

export const deleteRoom = async (roomId) => {
  const response = await deleteRequest(`/room/${roomId}`);
  return response;
};

export const reorderRooms = async (restaurantId, ids) => {
  const response = await putRequest(`/room/reorder/${restaurantId}`, { ids });
  return response;
};

// Table API functions
export const getTablesByRestaurant = async (restaurantId) => {
  const response = await getRequest(`/table/restaurant/${restaurantId}`);
  return response;
};

export const getFreeTables = async (restaurantId) => {
  const response = await getRequest(`/table/restaurant/${restaurantId}/free`);
  return response;
};

/** Get table overview (rooms + tables + active bookings). Replaces dual fetch of rooms + tables. */
export const getTableOverview = async (restaurantId) => {
  const response = await getRequest(
    `/table/restaurant/${restaurantId}/overview`
  );
  return response;
};

/** Quick-book a table (walk-in / manual booking without order). */
export const quickBookTable = async (tableId, data) => {
  const response = await postRequest(`/table/${tableId}/quick-book`, data);
  return response;
};

/** Get bookings for a table. */
export const getTableBookings = async (tableId, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = queryString
    ? `/table/${tableId}/bookings?${queryString}`
    : `/table/${tableId}/bookings`;
  const response = await getRequest(url);
  return response;
};

/** Get available tables for a time slot. */
export const getAvailableTables = async (restaurantId, params) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await getRequest(
    `/table/restaurant/${restaurantId}/available?${queryString}`
  );
  return response;
};

/** Cancel a table booking. */
export const cancelBooking = async (tableBookingId) => {
  const response = await deleteRequest(`/tablebooking/${tableBookingId}`);
  return response;
};

/** Extend a table booking by 15 minutes. */
export const extendBooking = async (tableBookingId) => {
  const response = await patchRequest(`/tablebooking/${tableBookingId}/extend`);
  return response;
};

/** Update restaurant default booking duration (hours). */
export const updateDefaultBookingDuration = async (restaurantId, duration) => {
  const response = await patchRequest(
    `/restaurant/${restaurantId}/defaultBookingDuration`,
    { defaultBookingDuration: duration }
  );
  return response;
};

/** Update restaurant auto-accept bookings setting. */
export const updateAutoAcceptBookings = async (restaurantId, enabled) => {
  const response = await patchRequest(
    `/restaurant/${restaurantId}/enableAutoAcceptBookings`,
    { enableAutoAcceptBookings: enabled }
  );
  return response;
};

export const getTablesByRoom = async (roomId) => {
  const response = await getRequest(`/table/room/${roomId}`);
  return response;
};

export const getTableById = async (tableId) => {
  const response = await getRequest(`/table/${tableId}`);
  return response;
};

export const createTable = async (restaurantId, data) => {
  const cleanPayload = {
    ...data,
    numberOfPlaces: parseInt(data.numberOfPlaces),
    roomId: data.roomId != null ? parseInt(typeof data.roomId === "object" ? data.roomId.value : data.roomId) : null,
  };
  const response = await postRequest(
    `/table/restaurant/${restaurantId}`,
    cleanPayload
  );
  return response;
};

export const updateTable = async (tableId, data) => {
  const response = await putRequest(`/table/${tableId}`, data);
  return response;
};

export const deleteTable = async (tableId) => {
  const response = await deleteRequest(`/table/${tableId}`);
  return response;
};

export const reorderTablesInRoom = async (roomId, ids) => {
  const response = await putRequest(`/table/reorder/room/${roomId}`, { ids });
  return response;
};

export const reorderTablesInRestaurant = async (restaurantId, ids) => {
  const response = await putRequest(
    `/table/reorder/restaurant/${restaurantId}`,
    { ids }
  );
  return response;
};

/** Duplicate a table by its ID. */
export const duplicateTable = async (tableId) => {
  const response = await postRequest(`/table/${tableId}/duplicate`);
  return response;
};

export const moveTable = async (tableId, roomId, order) => {
  const response = await putRequest(`/table/${tableId}/move`, {
    roomId,
    order,
  });
  return response;
};

// Order table assignment functions
export const getOrderTables = async (orderId) => {
  const response = await getRequest(`/order/${orderId}/tables`);
  return response;
};

export const assignTablesToOrder = async (orderId, tableIds) => {
  const response = await postRequest(`/order/${orderId}/tables`, { tableIds });
  return response;
};

export const removeTablesFromOrder = async (orderId, tableIds = null) => {
  const data = tableIds ? { tableIds } : {};
  const response = await deleteRequest(`/order/${orderId}/tables`, data);
  return response;
};
